import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { accountGetAll, accountUpdate } from 'middleware/account/actions';
import AdminTool from './adminTool';

const mapStateToProps = (state) => {
  const {
    isLoggedIn,
    isLoading,
    role,
    accountList,
  } = state.accountReducer;
  return {
    isLoggedIn,
    isLoading,
    role,
    accountList,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      accountGetAll,
      accountUpdate,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTool);
